import { MapLayerSwitcherOverlays } from "esdm-map/dist/map/MapLayerSwitcherOverlays"
import { IMap } from "esdm-map/dist/map/IMap";
import { IMapViewStore } from "esdm-map/dist/map/store/IMapViewStore"
import { LayerGroupCollections } from "esdm-map/dist/layers/groups/LayerGroupCollections";
import { IMappingTextPack } from "esdm-map/dist/resources/MappingTextPack";
import { IVectorLayerGroup } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroup";

import { defaults as interactionDefaults} from 'ol/interaction';
import { defaults as controlDefaults} from 'ol/control';
import View from "ol/View";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import Polygon from "ol/geom/Polygon";
import LineString from "ol/geom/LineString";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import OLMap from 'ol/Map';
import { param } from "jquery";

export class CustomMapLayerSwitcherOverlays extends MapLayerSwitcherOverlays {
    
    constructor(
        private map: IMap,
        private mapStore: IMapViewStore,
        private allLayers: LayerGroupCollections,
        private mappingTextPack: IMappingTextPack) {
        super(map, mapStore, allLayers, mappingTextPack);
    }

    //Modified to insert relative url either to fixed image/svg or MapServer GetLegendGraphic request
    protected addLegendMap = (
        legendMapId: string,
        legendContainer: JQuery<HTMLElement>,
        layerGrp: IVectorLayerGroup): void =>
    {

        switch (layerGrp.ref) {
            case "Monuments": {
                legendContainer.empty();
                let imgUrl = "/api/OGCService/hbsmr?service=WMS&request=GetLegendGraphic&version=1.3.0&LAYER=MonumentPointsWFS&FORMAT=PNG&SLD_VERSION=1.1.0"
                legendContainer.append(this.getLegendMapElement(legendMapId, layerGrp.ref, imgUrl))
                break;
            }
            default: {
                super.addLegendMap(legendMapId, legendContainer, layerGrp);
            }
        }
    }

    private getLegendMapElement = (
        legendMapId: string,
        grpRef: string,
        imgUrl: string): JQuery<HTMLElement> => {

        let legendMapElement = $("<div/>", { id: legendMapId, class: "legendGraphic" });
        legendMapElement.append(`<img src="${imgUrl}" alt="Legend graphic for layer ${grpRef}"></img>`);

        return legendMapElement;
    }
}
